<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <v-card class="pt-7 pb-16" color="#fff">
        <v-row class="px-6">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <h3>افزودن کلاس خصوصی</h3>
            <v-btn
              :to="`/teacher/edit/${teacherId}`"
              class="white--text rounded-xl"
              height="40"
              color="thirdColor"
            >بازگشت</v-btn>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.title"
                  outlined
                  class="rounded-xl"
                  label="عنوان کلاس"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  label="تاریخ"
                  :value="model.date | moment(`jYYYY/jMM/jDD`)"
                  outlined
                  class="rounded-xl private-date-input"
                  readonly
                ></v-text-field>
                <date-picker
                  type="date"
                  v-model="model.date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                  custom-input=".private-date-input"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  label="ساعت برگزاری"
                  :value="model.event_time"
                  outlined
                  class="rounded-xl private-event-time-input"
                  readonly
                ></v-text-field>
                <date-picker
                  type="time"
                  v-model="model.event_time"
                  format="HH:mm:ss"
                  display-format="HH:mm:ss"
                  custom-input=".private-event-time-input"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.session_link"
                  outlined
                  class="rounded-xl"
                  label="لینک جلسه"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.price"
                  type="number"
                  outlined
                  class="rounded-xl"
                  label="قیمت"
                ></v-text-field>
                <p v-if="priceInWords" class="text-caption gray--text mt-1 mb-0">{{ priceInWords }} تومان</p>
                <div class="mt-2">
                  <div class="d-flex flex-wrap">
                    <v-chip
                      class="me-2 mb-2"
                      outlined
                      style="border-color: rgba(59, 65, 43, 1) !important; height: 30px !important;"
                      @click="setRecommendedPrice(500000)"
                    >500,000</v-chip>
                    <v-chip
                      class="me-2 mb-2"
                      outlined
                      @click="setRecommendedPrice(1000000)"
                      style="border-color: rgba(59, 65, 43, 1) !important; height: 30px !important;"
                    >1,000,000</v-chip>
                    <v-chip
                      class="me-2 mb-2"
                      outlined
                      @click="setRecommendedPrice(1500000)"
                      style="border-color: rgba(59, 65, 43, 1) !important; height: 30px !important;"
                    >1,500,000</v-chip>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.usd_price"
                  type="number"
                  outlined
                  class="rounded-xl"
                  label="قیمت خارجی(دلار)"
                  append-icon="mdi-currency-usd"
                  :disabled="loading"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.special_price"
                  type="number"
                  outlined
                  class="rounded-xl"
                  label="قیمت خارجی(ریال)"
                ></v-text-field>
                <p v-if="specialPriceInWords" class="text-caption gray--text mt-1 mb-0">{{ specialPriceInWords }} تومان</p>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.foreign_payment_rial_link"
                  outlined
                  class="rounded-xl"
                  label="لینک پرداخت ریال"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.foreign_payment_usd_link"
                  outlined
                  class="rounded-xl"
                  label="لینک پرداخت دلار"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="text-left">
                <v-btn
                  width="140"
                  height="32"
                  color="nagative"
                  class="white--text me-2 rounded-lg"
                  :to="`/teacher/edit/${teacherId}`"
                >انصراف</v-btn>
                <v-btn
                  width="140"
                  height="32"
                  class="white--text rounded-lg"
                  type="submit"
                  color="positive"
                  :loading="loading"
                  @click="create"
                >ثبت</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import courseApi from "@/Services/modules/courses";

export default {
  name: "private-class-create",

  data() {
    return {
      loading: false,
      model: {
        title: "",
        date: "",
        event_time: "",
        session_link: "",
        price: "0",
        usd_price: "0",
        special_price: "0",
        foreign_payment_rial_link: "",
        foreign_payment_usd_link: "",
      },
    };
  },

  computed: {
    /**
     * Teacher ID
     */
    teacherId() {
      return Number(this.$route.params.teacherId);
    },
    /**
     * Price in Persian words
     */
    priceInWords() {
      const n = parseInt(this.model.price, 10);
      if (isNaN(n) || n < 0) return "";
      if (n === 0) return "صفر";
      return this.numberToWords(n);
    },
    /**
     * Special price in Persian words
     */
    specialPriceInWords() {
      const n = parseInt(this.model.special_price, 10);
      if (isNaN(n) || n < 0) return "";
      if (n === 0) return "صفر";
      return this.numberToWords(n);
    },
  },

  methods: {
    /**
     * Convert number to Persian words
     */
    numberToWords(n) {
      const ones = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
      const tens = ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
      const teens = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];
      const hundreds = ["", "صد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];

      const toWords = (num) => {
        if (num === 0) return "";
        if (num < 10) return ones[num];
        if (num < 20) return teens[num - 10];
        if (num < 100) return (tens[Math.floor(num / 10)] + (num % 10 ? " و " + ones[num % 10] : "")).trim();
        if (num < 1000) return (hundreds[Math.floor(num / 100)] + (num % 100 ? " و " + toWords(num % 100) : "")).trim();
        if (num < 1000000) return (toWords(Math.floor(num / 1000)) + " هزار" + (num % 1000 ? " و " + toWords(num % 1000) : "")).trim();
        if (num < 1000000000) return (toWords(Math.floor(num / 1000000)) + " میلیون" + (num % 1000000 ? " و " + toWords(num % 1000000) : "")).trim();
        return (toWords(Math.floor(num / 1000000000)) + " میلیارد" + (num % 1000000000 ? " و " + toWords(num % 1000000000) : "")).trim();
      };
      return toWords(n);
    },
    /**
     * Set Recommended Price
     * @param val 
     */
    setRecommendedPrice(val) {
      this.model.price = String(val);
    },

    
    toApiTime(t) {
      if (!t) return "";
      const s = String(t).trim();
      if (s.includes("Z")) return s.slice(0, 5);
      if (s.length >= 5) return s.slice(0, 5);
      if (s.length === 4) return s + "0";
      return s;
    },

    /**
     * Create Private class: 1) base course, 2) performing class
     */
    create() {
      if (!this.model.title || !this.model.date) {
        this.$toast.error("عنوان و تاریخ الزامی است.");
        return;
      }
      this.loading = true;

      const basePayload = {
        course_type: "In_Person",
        is_active: true,
        title: this.model.title,
        price: String(this.model.price ?? "0"),
        usd_price: String(this.model.usd_price ?? "0"),
        special_price: String(this.model.special_price ?? "0"),
        foreign_payment_rial_link: this.model.foreign_payment_rial_link || "",
        foreign_payment_usd_link: this.model.foreign_payment_usd_link || "",
        category: null,
        priority: null,
      };

      courseApi
        .addStepToCourse(basePayload)
        .then((res) => {
          const baseCourseId = res?.data?.id;
          if (!baseCourseId) {
            this.$toast.error("خطا در ایجاد دوره مادر.");
            return;
          }
          const performingPayload = {
            parent_course: baseCourseId,
            title: this.model.title,
            start: this.model.date,
            event_time: this.toApiTime(this.model.event_time),
            session_link: this.model.session_link || "",
            capacity: 1,
            teachers: [this.teacherId],
          };
          return courseApi.createClass(performingPayload);
        })
        .then(() => {
          this.$toast.success("کلاس خصوصی با موفقیت ایجاد شد!");
          this.$router.push(`/teacher/edit/${this.teacherId}`);
        })
        .catch((err) => {
          this.$toast?.error(err?.response?.data?.message || "خطا در ایجاد کلاس خصوصی");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>


